// extracted by mini-css-extract-plugin
module.exports = {"arrow":"SidebarArrow_arrow__gemRY","collapsed":"SidebarArrow_collapsed__tMcRM","toggleButton":"SidebarArrow_toggleButton__ft8yw","outside":"SidebarArrow_outside__BYHbs"};